import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  styleUrls: ['./home.component.scss'],
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  menus: MenuItem[] = [
    {
      label: environment.names.bef,
      icon: 'pi ihg153',
      command: () => {
        window.open(`https://ls.ihg-wo.com?nocache=${Date.now()}`, '_blank');
      },
    },
    {
      label: environment.names.scheduler,
      icon: 'pi ihg11',
      command: () => {
        window.open(`https://tp.ihg-wo.com?nocache=${Date.now()}`, '_blank');
      },
    },
    {
      label: 'Tableau Hotel Reports',
      icon: 'pi ihg20',
      command: () => {
        window.open('https://tableau.ihg.com/#/site/Departmental/projects/1818?:origin=card_share_link', '_blank');
      },
    },
    {
      label: 'UKG EU IMEA (SSO)',
      icon: 'pi ihg4',
      styleClass: 'ukg-eu',
      command: () => {
        window.open('https://ihghotels-sso.prd.mykronos.com', '_blank');
      },
    },
    {
      label: 'UKG SEAK JAPAC (SSO)',
      icon: 'pi ihg4',
      styleClass: 'ukg-japac',
      command: () => {
        window.open('https://ihghotels2-sso.prd.mykronos.com', '_blank');
      },
    },
    {
      label: 'UKG AMER (SSO)',
      icon: 'pi ihg4',
      styleClass: 'ukg-amer',
      command: () => {
        window.open('https://ihghotelsamer.prd.mykronos.com/', '_blank');
      },
    },
    {
      label: 'Original JAPAC UKG System',
      icon: 'pi ihg4',
      command: () => {
        window.open('https://ihg.prd.mykronos.com', '_blank');
      },
    },
    {
      label: 'Service Now Support Ticket',
      icon: 'pi ihg146',
      styleClass: 'support',
      command: () => {
        window.open('https://ihg.sharepoint.com/sites/WorkforceOptimisation/SitePages/How-to-Raise-a-Service-Now-Ticket-.aspx', '_blank');
      },
    },
    {
      label: 'UKG Support Website (Sharepoint)',
      icon: 'pi ihg196',
      styleClass: 'support',
      command: () => {
        window.open('https://ihg.sharepoint.com/sites/WorkforceOptimisation/SitePages/UKG.aspx', '_blank');
      },
    },
    {
      label: 'Workforce Optimisation Support Website',
      icon: 'pi ihg196',
      styleClass: 'support',
      command: () => {
        window.open('https://ihg.sharepoint.com/sites/WorkforceOptimisation', '_blank');
      },
    },
  ];

  adminMenu = {
    label: 'Admin Applications',
    icon: 'pi ihg48',
    routerLink: ['/admin'],
  };

  constructor() {}

  ngOnInit() {}
}
